<template>
	<v-app :style="imageStyle">
		<v-content class="relative">
			<div class="support-links">
				<!-- <v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							class="pr-4"
							v-bind="attrs"
							v-on="on"
							@click="openUrl('docs')"
						>
						mdi-help-circle-outline
						</v-icon>
					</template>
					<span>View documentation</span>
				</v-tooltip> -->
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
						class="pr-4"
							v-bind="attrs"
							v-on="on"
							@click="openUrl('ticket')"
						>
						mdi-ticket-outline
						</v-icon>
					</template>
					<span>Create a support ticket</span>
				</v-tooltip>
			</div>
			
			<v-container fluid fill-height class="loginOverlay">
				<v-layout flex align-start justify-center align-center>
					<v-flex xs12 sm8 md6 lg4>
						<v-row align="center" justify="center">
							<v-col align="center" justify="center">
								<v-img
									:width="360"
									:src="cmLogo"
								></v-img>
							</v-col>
						</v-row>

						<div class="login">
							<v-card color="#13294b" raised tile min-height="358">
								<v-card-text class="pt-4" style="overflow:hidden;">
									<p v-if="type === 'confirmCode'" class="white-text">Your password has been reset.</p>
									<new-password
										v-if="type === 'NewPassword'"
										:user="user"
										:response="handleLoginResponse"
										@auth-state="handleAuthState"
										@back="handleBack"
									/>
									<forgot-password
										v-else-if="type === 'ForgotPassword'"
										:email="email"
										@auth-state="handleAuthState"
									/>
									<Login
										v-else-if="type === 'Login' || type === 'confirmCode'"
										:response="handleLoginResponse"
										@auth-state="handleAuthState"
										@storeCreds="handleCredentials"
									/>
									<VerifyMFA
										v-else-if="type === 'VerifyMFA'"
										:user="user"
										:response="handleLoginResponse"
										:credentials="loginCredentials"
										@auth-state="handleAuthState"
									/>
									<Setup-mfa 
										v-else-if="type == 'setupMfa'"
										:user="user"
										@setupSmsMfa="setupSmsMfa"
										@setup-app-mfa="setupAppMfa"
										@skipMfa="skipMfaSetup"
										@proceed="handleLoginResponse"
									/>
									<setup-sms
										v-else-if="type == 'setupSms'"
										:user="cognitoUser"
										@proceed="handleLoginResponse"
										@back="handleBack"
									/>
									<v-skeleton-loader v-else class="mx-auto" type="card"></v-skeleton-loader>
								</v-card-text>
								<v-card-text v-if="showServiceAnnouncement">
									<v-container>
										<v-row class="pl-0">
											<v-col cols="1" class="pl-0 justify-start d-flex">
												<v-icon size="40" class="announcement-icon">
													mdi-bullhorn-outline
												</v-icon>
											</v-col>
											<v-col cols="10" class="pl-0 pt-6 justify-start d-flex announcement-heading"><h3>Service Announcement</h3></v-col>
										</v-row>
										<v-row>
											<v-col cols="12" class="justify-start d-flex pt-0 pl-1">
												<div class="annoucement-text cm-scroll-bar">
													{{ serviceMessageText }}
												</div>
											</v-col>
										</v-row>
									</v-container>
								</v-card-text>
							</v-card>
						</div>
						
					</v-flex>
					<v-dialog v-model="displayMfaNag" persistent content-class="mfa-nag">
						<v-card width="540">
							<v-card-title class="nag-title">Two factor authentication is not currently enabled for your account</v-card-title>
							<v-row>
								<v-col cols="12">	
									<v-btn 
										color="#07B7B1" 
										class="white--text no-uppercase"
										size="small"
										variant="flat"
										@click="setupMfa"
									>
										Set up two factor authentication now
									</v-btn>
								</v-col>
							</v-row>

							<v-row>
								<v-col cols="12">	
									<v-btn class="skip-btn no-uppercase" text color="#CC0000" @click="skipMfaSetup">
										I will do this later
									</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-dialog>
				</v-layout>
			</v-container>
			<v-img
				class="cm-icon"
				:width="60"
				:src="cmIcon"
			></v-img>
		<div class="footer-bar"></div>
		
		</v-content>
		
	</v-app>
</template>

<script>
	//  pipeline test
	import bg from "@/assets/bg_image.jpeg";
	import logo from "@/assets/logo.png";
	import icon from "@/assets/cm-icon.png";

	import Login from "./components/Login.vue";
	import VerifyMFA from "./components/verifyMFA.vue"
	import SetupMfa from "./components/setupMfa.vue"
	import SetupSms from "./components/setupSms.vue"

	import {getAnnouncements} from '@/helpers/ServiceAnnouncements.js'

	export default {
		components: {
			Login,
			VerifyMFA,
			SetupMfa,
			SetupSms,
			"new-password": () => import("./components/confirmNewPassword.vue"),
			"forgot-password": () => import("./components/forgotPassword.vue")
		},

		data: () => ({
			apiName: "PVAPI",
			bg: bg,
			user: {},
			email: "",
			type: "Login",
			opacity: 0,
			goDriveReset: false,
			loginCredentials: {},
			displayMfaNag: false,
			cognitoUser: {},
			resQueryStr: '',
			serviceMessageText: '',
			showServiceAnnouncement: false
			}),
	
		computed: {
			imageStyle () { 
				return {
					backgroundImage: `url(${bg})`, 
					"background-size": "cover",
					"background-repeat": "none",
					"background-position": "center"
				}
			},
			cmLogo() {
				return logo;
			},
			cmIcon() {
				return icon;
			}
		},
		
		watch: {
			type(val) {
				// If the password has been reset and the user came from godrive, send them back to the godrive login page
				if(val == 'confirmCode' && this.goDriveReset == true) {
					this.goDriveRedirect();
				}
			}
		},

		mounted() {
			// we want to clear any existing local storage when the page loads. 
			// we will still have our cookies containing refresh tokens, etc :) 
			
			window.localStorage.clear() 
			this.opacity = 1;
			this.$on("auth-state", evt => this.handleAuthState(evt));
			this.getQueryParam();
			this.getAnnouncements()
		},

		methods: {
			async getAnnouncements() {
				const announcement = await getAnnouncements()

				if(announcement && Object.prototype.hasOwnProperty.call(announcement, 'ServiceMessage')) {
					if(announcement.ServiceMessage.length > 0) {
						this.showServiceAnnouncement = true
						this.serviceMessageText = announcement.ServiceMessage
					}
				}
			},
			handleBack() {
				// eslint-disable-next-line no-console
				console.log('handleBack')
				this.type = 'Login'
			},

			setupSmsMfa() {
				// eslint-disable-next-line no-console
				console.log('setup sms mfa')
				this.type = 'setupSms'
			},

			setupAppMfa() {

			},

			handleCredentials(data) {
				// eslint-disable-next-line no-console
				console.log('handle creds', data)
				this.loginCredentials = data
			},

			getQueryParam() {
				const params = new Proxy(new URLSearchParams(window.location.search), {
					get: (searchParams, prop) => searchParams.get(prop),
				});
				let resetPassword = params.reset; 
				let userEmail = params.user_email;
		
				if (resetPassword == 'true') {
					this.goDriveReset = true;
					this.email = userEmail;
					this.type = "ForgotPassword";
				}
			},

			handleAuthState(evt) {
				// eslint-disable-next-line no-console
				console.log('handleAuthState', evt)
				switch (evt.type) {
					case "NewPassword":
						this.user = evt.user;
						break;

					case "ForgotPassword":
						this.email = evt.email;
						break;

					case "VerifyMFA":
						this.user = evt.user;
						break;

					default:
						break;
				}
				this.type = evt.type;
			},
			// eslint-disable-next-line no-unused-vars
			async handleLoginResponse(user, queryStr) {
				// eslint-disable-next-line no-console
				console.log('AUTH PAGE USER', user);

				this.cognitoUser = user
				this.resQueryStr = queryStr

				if(user.challengeName == 'NEW_PASSWORD_REQUIRED') {
					this.$emit("auth-state", {
							type: "NewPassword",
							user: user
						});
				}
				else if (user.challengeName == 'SMS_MFA' && user.signInUserSession == null) {
					this.$emit("auth-state", {
							type: "VerifyMFA",
							user: user
						});
				}
				else if (user.preferredMFA == 'NOMFA') {
					this.displayMfaNag = true
				}
				else {
					this.handleNavigation(user, queryStr)
				}
			},

			handleNavigation(user, queryStr) {
				// eslint-disable-next-line no-console
				console.log('handleNavigation', user, queryStr)
				try {
					const availableServices = user.signInUserSession.getIdToken().payload["custom:services"]
					const servicesList = availableServices.split(/\s*,\s*/)

					if(servicesList.includes('cameramatics')) {
						if (user.signInUserSession.getIdToken().payload["custom:role"].toLowerCase() == 'sys_admin' || user.signInUserSession.getIdToken().payload["custom:role"].toLowerCase() == 'support_admin' || user.signInUserSession.getIdToken().payload["custom:role"].toLowerCase() == 'support_lead' || user.signInUserSession.getIdToken().payload["custom:role"].toLowerCase() == 'firmware_manager') {
							this.navigateToAdmin(queryStr);
						} else {
							this.navigateToCustomer();
						}
					}
					else if(servicesList.includes('safetyCentre')) {
						this.goDriveRedirect()
					}
					else if(servicesList.length == 1 && servicesList[0] == 'zero') {
						this.navigateToZero()
					}
				}

				catch {
					return false
				}
			},

			skipMfaSetup() {
				// eslint-disable-next-line no-console
				console.log('skipMfaSetup', this.cognitoUser, this.resQueryStr)
				this.handleNavigation(this.cognitoUser, this.resQueryStr)
			},

			setupMfa() {
				this.displayMfaNag = false
				this.type = 'setupMfa'
			},

			navigateToAdmin(query) {
				if (query) {
					location.replace(
						location.protocol + "//" + process.env.VUE_APP_user_domain + '?orgID=' + query
					);
				} else {
					location.replace(
						location.protocol + "//" + process.env.VUE_APP_admin_domain
					);
				}
				
			},
			navigateToCustomer() {
				location.replace(
					location.protocol + "//" + process.env.VUE_APP_user_domain
				);
			},

			goDriveRedirect() {
				location.replace(
					location.protocol + "//" + process.env.VUE_APP_go_portal_redirect + '/landing/Dashboard'
				);
			},

			navigateToZero() {
				location.replace(
					location.protocol + "//" + process.env.VUE_APP_zero_domain
				)
			},
			openUrl(url) {
				if(url == 'docs') {
					window.open('', '_blank').focus()
				}
				if(url == 'ticket') {
					window.open('https://cameramatics.my.salesforce-sites.com/cameramaticstechnicalsupport', '_blank').focus()
				}
			}
		}
	};
</script>

<style lang='scss'>
	#app {
		transition: opacity 0.5s ease-in-out;
		font-family: "Roboto", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		background-size: cover;
		overflow: hidden;
		.v-toolbar.primary {
			
			.v-toolbar__content {
				margin-left: 0 !important;
				.v-toolbar__title {
					width: 100%;
					text-align: center;
				}
			}
		}
		.error-callback {
			ul {
				padding-left: 0;
				li {
					list-style: none;
					text-align: left;
					color: red;
				}
			}
		}
	}
	.photoCredit {
		position: absolute;
		bottom: 15px;
		right: 15px;
	}
	.relative {
		position: relative;
	}
	.login {
		width: 600px;
		border-left: 5px solid #3db0ad;
		margin-top: 5vh !important;

		.card-inner {
			padding: 40px 70px;
		}
	}
	.cm-icon {
		display: block;
    position: absolute;
    bottom: 0;
	}
	.footer-bar {
		width: 100%;
    position: absolute;
    bottom: 0;
		border-bottom: 5px solid #3db0ad;
	}
	.mfa-nag {
		transform-origin: center center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: hidden;
			.nag-title {
				font-weight: normal !important;
			}
			.setup-mfa {
				color: white !important;
			}
			.skip-btn {
				font-size: 12px;
			}
			.no-uppercase {
				text-transform: unset !important;
			}
	}
	.white-text {
		color: white !important;
	}
	.v-input__slot {
		background: #EAEAEA !important;
		border-radius: 5px !important;
	}
	.v-text-field__slot {
		background: #EAEAEA !important;;
		border-radius: 5px !important;
	}

	.v-dialog--active {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    overflow-y: hidden !important;
	}
	.v-dialog > .v-card > .v-card__title {
		font-weight: 400!important;
	}
	.announcement-icon.theme--light.v-icon {
    color: #ecb726 !important;
	}
	.announcement-heading {
		color: #ecb726 !important;
	}
	.annoucement-text {
		text-align: justify;
    color: white;
    line-height: 1.2;
    max-height: 103px;
    display: block;
    overflow: auto;
    overflow-x: hidden;
		padding-right: 8px;
	}

	.cm-scroll-bar {
		&::-webkit-scrollbar {
			width: 5px;
			height: 10px;
		}

		&::-webkit-scrollbar-track {
			background: #5b5b5b;
		}

		&::-webkit-scrollbar-thumb {
			background: #aaa;
			transition: all 0.2s;

			&:hover {
				background: #999;
			}
		}
	}

	.support-links {
		position: absolute;
		right: 10px;
		top: 10px;
	}
</style>
